// @ts-nocheck
const STAKE_ACTIONS = {
  SET_COLLATOR_CANDIDATES: 'SET_COLLATOR_CANDIDATES',
  SET_USER_BALANCE: 'SET_USER_BALANCE',
  SET_USER_DELEGATIONS: 'SET_USER_DELEGATIONS',
  SET_UNSTAKE_REQUESTS: 'SET_UNSTAKE_REQUESTS',
  SET_STAKE_TARGET_BALANCE: 'SET_STAKE_TARGET_BALANCE',
  SET_UNSTAKE_TARGET_BALANCE: 'SET_UNSTAKE_TARGET_BALANCE',
  SET_SELECTED_COLLATOR: 'SET_SELECTED_COLLATOR',
  SET_SELECTED_UNSTAKE_REQUEST: 'SET_SELECTED_UNSTAKE_REQUEST',
  SET_USER_TOTAL_RECENT_REWARDS: 'SET_USER_TOTAL_RECENT_REWARDS'
};

export default STAKE_ACTIONS;
